import { useState } from "react";

function Brand() {
  return (
    <div className="min-h-screen select-none bg-zinc-900 text-white overflow-y-auto">
      <div className=" flex flex-col h-screen ">
        <div className="max-w-xl px-12 w-full mx-auto flex h-full flex-grow flex-col justify-center gap-4 p-14 bg-zinc-900">
          <div className="text-2xl font-medium">Branding Assets</div>
          <div className="text-sm relative">
            Hier findest du Grafiken und Logos, die du (z. B. für Streams,
            Videos oder Werbung) verwenden kannst.
            <br />
            <Accordion title="Bedingungen">
              <ul className="list-disc pl-4">
                <li>Die Grafiken dürfen nicht verändert werden.</li>
                <li>
                  Die Grafiken dürfen nicht für kommerzielle Zwecke verwendet
                  werden.
                </li>
                <li>
                  Die Grafiken dürfen nicht in Verbindung mit anderen Produkten
                  oder Dienstleistungen verwendet werden.
                </li>
                <li>
                  Die Grafiken dürfen nicht in Verbindung mit illegalen oder
                  anstößigen Inhalten verwendet werden.
                </li>
                <li>
                  Wir haften nicht für Schäden, die durch die Verwendung der
                  Grafiken entstehen.
                </li>
              </ul>
            </Accordion>
          </div>
          <div className="flex w-full flex-col justify-center items-center gap-2 mt-4">
            <Image
              src="/brand-assets/evolve_logo.png"
              alt="Evolve Logo"
              className="h-24"
            />
            <Image
              src="/brand-assets/project_logo.png"
              alt="Projekt Logo"
              className="h-24"
            />
            <Image
              src="/brand-assets/project_logo2.png"
              alt="Projekt Logo 2"
              className="h-8"
            />
          </div>
          <div className="h-1/5" />
        </div>
      </div>
    </div>
  );
}

function Accordion({ title, children }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="mt-2">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className="text-base font-medium">{title}</div>
        <div className="text-sm">
          {isOpen ? (
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 15l7-7 7 7"
              />
            </svg>
          ) : (
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="mt-4 border-b pb-2 border-neutral-600">{children}</div>
      )}
    </div>
  );
}

function Image({ src, alt, className = "" }) {
  return (
    <div className="flex flex-col items-end gap-1">
      <div className={"relative " + className}>
        <img src={src} alt={alt} className="w-full h-full object-contain" />
      </div>
      <button
        className="text-xs text-neutral-500 hover:text-neutral-400 hover:underline"
        onClick={() => {
          const link = document.createElement("a");
          link.href = src;
          link.download = alt;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }}
      >
        Herunterladen
      </button>
    </div>
  );
}

export default Brand;
